// extracted by mini-css-extract-plugin
module.exports = {"dni_file":"personal-data-styles_dni_file__1azk1"};